import { supabase } from '../supabase/client';
import type { EmailAnalyse } from './analyseApi';

export function istTriagierbar(analyse: EmailAnalyse, hatTicket: boolean): boolean {
  return analyse.cockpit_status === 'offen'
    && !!analyse.erkannte_aufgabe
    && !analyse.fehler
    && !analyse.ist_werbung
    && !hatTicket;
}

// Zählt offene, triagierbare Vorschläge (ohne die vollständigen Vorschlag-Objekte zu bauen).
export async function zaehleOffeneVorschlaege(): Promise<number> {
  const { data: analysen } = await supabase
    .from('email_analysen')
    .select('email_id, cockpit_status, erkannte_aufgabe, fehler, ist_werbung')
    .eq('cockpit_status', 'offen')
    .not('erkannte_aufgabe', 'is', null)
    .is('fehler', null)
    .eq('ist_werbung', false);
  const list = (analysen || []) as Pick<EmailAnalyse, 'email_id' | 'cockpit_status' | 'erkannte_aufgabe' | 'fehler' | 'ist_werbung'>[];
  if (!list.length) return 0;

  // Umgedreht statt .in('target_id', emailIds): Hunderte IDs sprengten die GET-URL
  // (Server antwortete 400). Alle Ticket↔Mail-quelle-Links sind wenige Zeilen —
  // komplett laden und lokal matchen.
  const { data: links } = await supabase
    .from('entity_links').select('target_id')
    .eq('source_type', 'ticket').eq('target_type', 'email').eq('link_type', 'quelle');
  const hatTicket = new Set((links || []).map((l: any) => l.target_id));

  return list.filter((a) => !hatTicket.has(a.email_id)).length;
}
